import { render, staticRenderFns } from "./DashboardStorageSize.vue?vue&type=template&id=59316955&scoped=true"
import script from "./DashboardStorageSize.vue?vue&type=script&lang=js"
export * from "./DashboardStorageSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59316955",
  null
  
)

export default component.exports